var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 8C5.97119 8 7.0625 6.90869 7.0625 5.5625C7.0625 4.21631 5.97119 3.125 4.625 3.125C3.27881 3.125 2.1875 4.21631 2.1875 5.5625C2.1875 6.90869 3.27881 8 4.625 8Z",
    stroke: "#AF7C2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78516 3.21581C8.12042 3.12135 8.47203 3.09983 8.8163 3.1527C9.16058 3.20557 9.48953 3.3316 9.78099 3.52231C10.0725 3.71302 10.3197 3.96397 10.506 4.25827C10.6923 4.55256 10.8134 4.88337 10.8611 5.2284C10.9088 5.57343 10.882 5.92467 10.7825 6.25848C10.683 6.59228 10.5132 6.90089 10.2844 7.16352C10.0556 7.42615 9.77315 7.6367 9.45613 7.781C9.13912 7.92529 8.79486 7.99997 8.44654 8.00001",
    stroke: "#AF7C2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.75297C1.63069 9.21147 2.13607 8.76951 2.72349 8.46441C3.31091 8.15931 3.96311 8.00003 4.62504 8C5.28696 7.99997 5.93918 8.15921 6.52662 8.46427C7.11406 8.76932 7.61948 9.21124 8.00021 9.75271",
    stroke: "#AF7C2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44629 8C9.10828 7.99952 9.76063 8.15856 10.3481 8.46366C10.9356 8.76875 11.4409 9.21092 11.8213 9.75271",
    stroke: "#AF7C2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.95a9609a49e07e5098a5cc94c8093255.svg";
export { ForwardRef as ReactComponent };